import { SaleOrderStatus, TokenStatus } from '@do/models';

import type { ArtAssetCardData, ArtAssetDto, ArtAssetPurchasedListItem } from '../types';

export function mapApiToArtAssetCardData(item: ArtAssetDto): ArtAssetCardData {
  return {
    image: item.main_photo,
    name: item.name_english ?? item?.name_original ?? '',
    price: getArtAssetPrice(item),
    year: item.creation_year,
    slug: `artwork-${item.id}-${item.slug}`,
    status: item.token_status as TokenStatus,
    artist: item.artists?.map((item) => item.name).join(', ') ?? null,
    featured: item.featured,
  };
}

export function mapPurchasedArtAssetApiToArtAssetCardData(item: ArtAssetPurchasedListItem): ArtAssetCardData {
  return {
    image: item.main_photo,
    name: item.name_english ?? item?.name_original ?? '',
    price: item.realized_price || null,
    year: item.creation_year,
    slug: `collector/artwork-${item.id}-${item.slug}`,
    status: item.token_status as TokenStatus,
    artist: item.artists?.map((item) => item.name).join(', ') ?? null,
  };
}

function getArtAssetPrice(item: ArtAssetDto): number | null {
  if (item.token_status === TokenStatus.Sold && item.auction?.best_bid) {
    return item.auction.best_bid.value_formatted;
  }

  if (
    item.token_status === TokenStatus.Sold ||
    item.token_status === TokenStatus.OnSale ||
    item.sale_order?.status === SaleOrderStatus.Placed
  ) {
    return item?.sale_order?.price_formatted || item.estimate_price;
  }

  return null;
}
